import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Logbook } from 'src/app/data-models/user-models/logbook.model';
import { VesselData } from 'src/app/data-models/user-models/vessel-data.model';
import { SharedMethodsService } from 'src/app/services/shared-methods.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-add-logbook-dialog',
    templateUrl: './add-logbook-dialog.component.html',
    styleUrls: ['./add-logbook-dialog.component.css'],
    standalone: false
})
export class AddLogbookDialogComponent implements OnInit {

  duplicateLogbookFlag: boolean = false; // used if the logbook ID entered is not unique

  logbookForm: UntypedFormGroup = new UntypedFormGroup({
    logbookNumber: new FormControl<string>('', [Validators.required]),
    gearType: new FormControl<string>('', [Validators.required]),
    vesselName: new FormControl<string>('', [Validators.required]),
    vesselNumber: new FormControl<string>('', [Validators.required]),
  });

  constructor (
    public dialogRef: MatDialogRef<AddLogbookDialogComponent>,
    public dialog: MatDialog,
    public sharedMethodsService: SharedMethodsService,
    @Inject(MAT_DIALOG_DATA) public data: { logbook: Logbook, currLogbooks: Logbook[] }
  ) {}


  /*  ---------- Initialization Methods  ---------- */


  ngOnInit(): void {
    if (this.data.logbook.isValid()) {
      this.logbookForm.patchValue({
        logbookNumber: this.data.logbook.logbookID,
        gearType: this.data.logbook.gearName,
        vesselName: this.data.logbook.vessel.vesselName,
        vesselNumber: this.data.logbook.vessel.vesselRegistrationNumber
      });
      this.logbookForm.get('logbookNumber')?.disable();
      this.logbookForm.get('gearType')?.disable();
    }
  }


  /*  ---------- Validation Methods  ---------- */

  // checks to see if currLogbook is a duplicate of one of the user's pre-existing logbooks
  isLogbookUnique(): boolean {
    let num = this.logbookForm.get('logbookNumber')?.value.trim();
    //If this is an edit then only run this check if the logbook number field has been changed
    return !this.data.logbook.isValid() ? !this.data.currLogbooks.some(lb => lb.logbookID == num) : true;
  }


  checkForDuplicateLogbook(): boolean {

    // call method that checks if a logbook with the same ID already exists
    if (this.isLogbookUnique()) {
      return false;
    }
    this.sharedMethodsService.toastLogbookUniqueError();
    return true;

  }


  /*  ---------- Dialog Close Methods  ---------- */


  // invoked when the user presses the 'add' button; saves the added data to user storage
  addLogbook(): void { 

    this.duplicateLogbookFlag = false;

    if (this.logbookForm.invalid) {
      this.logbookForm.markAllAsTouched();
      return;
    }

    if (!this.checkForDuplicateLogbook()) this.dialogRef.close(
      new Logbook(this.logbookForm.get('gearType')?.value.trim(),
      this.logbookForm.get('logbookNumber')?.value.trim(),
      new VesselData(this.logbookForm.get('vesselName')?.value.trim(), this.logbookForm.get('vesselNumber')?.value.trim()),
      new Date().getFullYear()));

  }


  deleteLogbook() {
    this.dialog.open(ConfirmationDialogComponent, {
      data: { screen: 'delete_logbook' }
    }).afterClosed().subscribe(result => {
      if (result) this.dialogRef.close('delete');
      
    })
  }

}
